<template>
  <div id="app">
    <DefaultLayout/>
  </div>
</template>

<script>
import DefaultLayout from '@/views/layouts/DefaultLayout';

export default {
  components: {
    DefaultLayout,
  },
};
</script>

<style lang="scss">
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
</style>
